module.exports = require('react/lib/ReactCSSTransitionGroup');


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-addons-css-transition-group/index.js
// module id = 924
// module chunks = 0 3 5